/* global axios */

class CallRecordsApi {
  accountIdFromRoute() {
    const isInsideAccountScopedURLs =
      window.location.pathname.includes('/app/accounts');

    if (isInsideAccountScopedURLs) {
      return window.location.pathname.split('/')[3];
    }

    return '';
  }

  baseUrl(conversationId) {
    const accountId = this.accountIdFromRoute();
    return `/api/v1/accounts/${accountId}/conversations/${conversationId}/call_records`;
  }

  requestPermission(conversationId, payload = {}) {
    return axios.post(`${this.baseUrl(conversationId)}/request_permission`, payload);
  }

  permissionStatus(conversationId) {
    return axios.get(`${this.baseUrl(conversationId)}/permission_status`);
  }

  initiate(conversationId, payload = {}) {
    return axios.post(`${this.baseUrl(conversationId)}/initiate`, payload);
  }

  terminate(conversationId, payload = {}) {
    return axios.post(`${this.baseUrl(conversationId)}/terminate`, payload);
  }

  logInbound(conversationId, payload = {}) {
    return axios.post(`${this.baseUrl(conversationId)}/log_inbound`, payload);
  }

  logSipCall(conversationId, payload = {}) {
    return axios.post(`${this.baseUrl(conversationId)}/log_sip_call`, payload);
  }

  attachRecording(conversationId, payload = {}, headers = {}) {
    return axios.post(`${this.baseUrl(conversationId)}/attach_recording`, payload, { headers });
  }
}

export default new CallRecordsApi();
